<template>
  <template v-if="post">
    <div v-if="canMoveBackward" class="gmf-post-modal-arrow" style="left: 50px; transform: translate(-50%, -50%);" @click="moveComment(neighborIndex - 1)"><Icon icon="chevron-right" style="transform: rotate(180deg);" /></div>
    <div v-if="canMoveForward" class="gmf-post-modal-arrow" style="right: 50px; transform: translate(50%, -50%)" @click="moveComment(neighborIndex + 1)"><Icon icon="chevron-right" /></div>
    <template v-if="isDesktop && selectedComment?.content?.images?.length">
      <div class="gmf-post-modal-content gmf-context">
        <div class="gmf-post-modal-content-image"
          @pointerdown="pointerDown"
          @pointermove="pointerMove"
          @wheel="wheel"
          :style="desktopContainerStyle"
        >
          <div class="gmf-post-modal-skeleton-loader">
            <LoadingSpinner v-if="!imageLoaded" class="gmf-post-modal-skeleton-loading-spinner" color="var(--gmf-col-white)" />
          </div>
          <img
            :style="desktopImageStyle"
            @load="imageLoaded = true"
            class="gmf-post-modal-content-image-img"
            ref="image"
            :src="selectedComment?.content?.images[selectedIndex].largeUrl || selectedComment?.content?.images[selectedIndex].url"
          />
          <div class="gmf-post-modal-content-image-zoom-buttons" @click.capture.prevent v-if="selectedComment?.content?.images?.length">
            <Icon icon="zoom-in" :disabled="zoom >= 6.0" @click="zoomIn"></Icon>
            <Icon icon="zoom-out" :disabled="zoom <= 1.0" @click="zoomOut"></Icon>
          </div>
        </div>
        <div class="gmf-post-modal-container gmf-scrollbar">
          <Post v-if="selectedComment" :post="selectedComment" @loadReplies="loadReplies" @update:votes="v => selectedComment.votes = v" :elements="{ images: false, uploads: true }" @selectedIndex="v => { selectedIndex !== v && (imageLoaded = false); selectedIndex = v; }" @selectedComment="(comment, index) => { overrideComment = comment; selectedIndex = index; }" :inPostModal="true" />

          <template v-if="! hideSocialFeedButton">
            <a v-if="socialFeedUrl" class="gmf-btn gmf-primary" :href="socialFeedUrl">{{ t('post_modal.social_feed_btn') }}</a>
            <div v-else class="gmf-btn gmf-primary" @click="openSocialModal({ displayHeader: true })">{{ t('post_modal.social_feed_btn') }}</div>
          </template>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="gmf-post-card" style="overflow-x: hidden;" @pointerdown="pointerDown" @pointermove="pointerMove" ref="postCard">
        <img
          class="gmf-post-card-image"
          ref="image"
          v-if="selectedComment?.content?.images?.length"
          :style="mobileImageStyle"
          :src="selectedComment?.content?.images[selectedIndex].largeUrl || selectedComment?.content?.images[selectedIndex].url"
        />

        <div class="gmf-post-card-content">          
          <Post v-if="selectedComment" :post="selectedComment" @loadReplies="loadReplies" @update:votes="v => selectedComment.votes = v" :elements="{ images: false, uploads: true }" @selectedIndex="v => selectedIndex = v" @selectedComment="(comment, index) => { overrideComment = comment; selectedIndex = index; }" :inPostModal="true" />  
          
          <template v-if="! hideSocialFeedButton">
            <a v-if="socialFeedUrl" class="gmf-btn gmf-primary" :href="socialFeedUrl">{{ t('post_modal.social_feed_btn') }}</a>
            <div v-else class="gmf-btn gmf-primary" @click="openSocialModal({ displayHeader: true })">{{ t('post_modal.social_feed_btn') }}</div>
          </template>
        </div>
      </div>
    </template>
  </template>
</template>

<style>
.gmf-modal-body.gmf-post-modal {
  padding: 0;
  max-width: 100%;
  height: auto;
  overflow: hidden;
  max-height: 100%;
}
@media (max-width: 1024px) {
  .gmf-modal-body.gmf-post-modal {
    overflow: hidden;
    background-color: var(--gmf-col-white) !important;
  }
  .gmf-post-modal-arrow {
    display: none !important;
  }
}

.gmf-modal-body:has(.gmf-post-card) {
  box-shadow: none !important;
}
@media (min-width: 1024px) {
  .gmf-modal-body.gmf-post-modal {
    height: 100% !important;
    max-height: min(800px, 100%) !important;
  }
  .gmf-modal-body.gmf-post-modal:not(:has(.gmf-post-modal-content-image)) {
    height: auto !important;
  }
}
.gmf-modal-body.gmf-post-modal:has(.gmf-post-card) {
  max-width: 500px;
  width: 100%;
  margin: auto;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.gmf-post-modal-arrow {
  position: fixed;
  top: 50%;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 100%;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  --gmf-icon-color: white;
}

.gmf-post-card-content-move-arrows {
  display: flex;
  justify-content: space-around;
}
.gmf-post-modal-arrow.gmf-disabled {
  opacity: 0.3;
  cursor: default;
  pointer-events: none;
}

.gmf-post-modal-content {
  display: flex;
  max-width: 100%;
  height: 100%;
  overflow: hidden;
  max-height: inherit;
}

.gmf-post-modal .gmf-card.gmf-sp {
  margin-bottom: 0;
  box-shadow: none;
  border: none !important;
  flex-grow: 1;
  width: 500px;
  max-width: 100%;
}

.gmf-post-modal-content-image {
  display: flex;
  background-color: black;
  overflow: hidden;
  position: relative;
  cursor: grab;
  flex: 1 1 0%;
  min-width: 0;
  min-height: 0;
  width: 100%;
  height: 100%;
  max-height: 100%;
}

.gmf-post-modal-content-image-zoom-buttons {
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: var(--gmf-p-3);
  z-index: 10;
}
.gmf-post-modal-content-image-zoom-buttons .gmf-icon {
  width: 36px;
  height: 36px;
  padding: 5px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 100%;
  cursor: pointer;
  transition: background 0.2s ease, opacity 0.2s ease;
  --gmf-icon-color: var(--gmf-col-white);
}
@media (hover: hover) {
  .gmf-post-modal-content-image-zoom-buttons .gmf-icon:hover {
    background: rgba(0, 0, 0, 0.7);
  }
}

.gmf-post-modal-content-image img {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  -webkit-user-drag: none;
  user-drag: none;
  user-select: none;
  object-fit: contain;
}

.gmf-post-modal-content-image-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.gmf-post-modal-container {
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-height: inherit;
  width: 100%;
  max-width: 500px;
  flex-basis: 500px;
  flex-grow: 0;
  flex-shrink: 0;
}

.gmf-post-modal-skeleton-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: black;
  display: flex;
  align-items: center;
  justify-content: center;
}

.gmf-post-card-image {
  position: sticky;
  top: 0px;
  object-fit: contain;
  width: 100%;
  max-height: 100%;
  background: black;
  z-index: 1;
}

.gmf-post-card {
  width: fit-content;
  max-width: 100%;
  
  display: flex;
  flex-direction: column;
  border-radius: var(--gmf-modal-rounding);

  height: 100%;
  height: fit-content;
}

.gmf-post-card::-webkit-scrollbar,
.gmf-post-card-content::-webkit-scrollbar {
  display: none;
}

.gmf-post-card-content {
  border-radius: 0 0 var(--gmf-modal-rounding) var(--gmf-modal-rounding);
  background: var(--gmf-col-white);
  position: relative;
  z-index: 2;

  display: flex;
  flex-direction: column;
}

.gmf-post-modal .gmf-card.gmf-sp .gmf-sp-action.gmf-text-small {
  padding-right: 32px;
}

@media (min-width: 1025px) {
  .gmf-modal-overlay:has(.gmf-post-modal) {
    padding: 60px;
    padding-inline: 100px;
  }
  .gmf-post-modal .gmf-card.gmf-sp {
    padding-top: var(--gmf-p-4);
  }
}

@media (max-width: 1024px) {
  .gmf-post-modal .gmf-post-card {
    height: 100% !important;
    max-height: inherit;
  }
}
.gmf-post-card {
  overflow: auto;
  max-height: 100%;
}

.gmf-post-card-content > .gmf-btn,
.gmf-post-modal-container > .gmf-btn {
  position: sticky;
  bottom: var(--gmf-p-4);
  margin: var(--gmf-p-3) auto;
  z-index: 1;
}

.gmf-post-modal-skeleton-loading-spinner {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
}
</style>

<script>
import { defineAsyncComponent } from 'vue';

import Icon from '@/components/Icon';
import LoadingSpinner from '@/components/LoadingSpinner';

const Post = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "stage-2" */'@/widgets/SocialFeed/Post');
});

import state from '@/state';
import callApi from '@/utils/callApi';
import modalStack from '@/utils/modalStack';
import openSocialModal from '../SocialFeed/openSocialModal';

const t = state.t;

function getIdMap(posts, idMap = {}) {
  for (const post of posts) {
    idMap[post.id] = post;
    if (post.replies) {
      getIdMap(post.replies, idMap);
    }
  }
  return idMap;
}

export default {
  name: 'PostModal',
  components: { Post, Icon, LoadingSpinner },
  inject: [
    'post',
    'modalState',
    'initialIndex',
    'moveComment',
    'canMoveForward',
    'canMoveBackward',
    'neighborIndex',
  ],
  data() {
    return {
      state,
      selectedIndex: this.initialIndex || 0,
      imageLoaded: false,
      
      order: 'created.desc',
      include: 'author,votes,targets,linkedProducts,pollVotes',

      overrideComment: null,
      
      activePointers: {},

      startX: 0,
      startY: 0,
      panX: 0,
      panY: 0,
      zoom: 1,
      initialPinchDistance: 0,
      initialZoom: 1,
      pinchCenterX: 0,
      pinchCenterY: 0,
      initialPanX: 0,
      initialPanY: 0,
      pinchImagePointX: 0,
      pinchImagePointY: 0,
      initialImageCenterX: 0,
      initialImageCenterY: 0,

      internalPost: JSON.parse(JSON.stringify(this.post)),
      posts: [],
    };
  },
  computed: {
    desktopImageStyle() {
      return {
        transform: `translate(${this.panX}px, ${this.panY}px) scale(${this.zoom})`,
        transformOrigin: 'center center',
        opacity: this.imageLoaded ? 1.0 : 0.0,
        transition: 'opacity 0.2s ease',
      };
    },
    mobileImageStyle() {
      return {
        transform: `translate(${this.panX}px, ${this.panY}px) scale(${this.zoom})`,
        transformOrigin: 'center center',
        maxHeight: '80%',
        flexShrink: 0,
        aspectRatio: `min(${this.selectedComment?.content?.images[this.selectedIndex].aspect}, 16/9)`,
        touchAction: this.zoom > 1.0 ? 'none' : 'pan-y pan-x',
      }
    },
    idMap() {
      return getIdMap(this.posts || []);
    },
    selectedComment () {
      return this.overrideComment || this.internalPost;
    },
    isDesktop() {
      return window.innerWidth > 1000;
    },
    desktopContainerStyle() {
      const currentImage = this.selectedComment?.content?.images?.[this.selectedIndex];
      const style = {};
      if (currentImage?.aspect) {
        style.aspectRatio = currentImage.aspect;
      }
      return style;
    },
    boardMap() {
      const map = {};

      for (const board of this.boards) {
        map[board.id] = board;
      }

      return map;
    },
    selectedBoard() {
      if (this.selectedFilter && this.selectedFilter.board_id) {
        const board = this.boardMap[this.selectedFilter.board_id];
        if (board) {
          return board;
        }
      }
      return null;
    },
    socialFeedUrl() {
      return state.merchantConfig?.widgets?.urls?.socialFeed;
    },
    hideSocialFeedButton() {
      for (const modal of modalStack.stack) {
        if (modal.app.$options.name === "SocialFeed") {
          return true;
        }
      }
      if(! state.merchantConfig?.socialFeed?.enabled) {
        return true;
      }
      
      return false;
    },
  },
  created() {
    if (!this.internalPost) {
      this.internalPost = JSON.parse(JSON.stringify(this.post));
    }
    this.posts = [this.internalPost];
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
    document.addEventListener('pointerup', this.pointerUp);
    document.addEventListener('pointercancel', this.pointerUp);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
    document.removeEventListener('pointerup', this.pointerUp);
    document.removeEventListener('pointercancel', this.pointerUp);
  },
  methods: {
    t,
    openSocialModal,
    
    handleKeydown(e) {
      if (! this.modalState.isTopModal) return;
      if (e.key === 'ArrowLeft') {
        this.moveComment(this.neighborIndex - 1);
      } else if (e.key === 'ArrowRight') {
        this.moveComment(this.neighborIndex + 1);
      }
    },
    async loadReplies(id) {
      try {
        const root = this.idMap[id];
        if (!root) {
          console.error('Failed to load replies: Parent comment not in view');
          return;
        }

        let skip = root.replies.length;
        if (skip && root.replies[0].replyCount === null) {
          skip = 0; // need to reload the replies
        }

        const query = {
          'skip': skip,
          'take': 3,
          'reply_count': 5,
          'reply_depth': 2,
          'root': this.internalPost.id,
          'translate': state.merchantConfig?.widgets?.translations.mode !== 'translateNothing',
          'include': 'author,votes,targets,linkedProducts,pollVotes',
        };
        const res = await callApi('GET', state.commentSearchEndpoint + '?' + new URLSearchParams(query).toString());
        const data = await res.json();
        
        for (const c of data.comments) {
          if (!(c.id in this.idMap)) {
            root.replies.push(c);
          } else {
            // Update existing comment, because it might have been a partial load
            Object.assign(this.idMap[c.id], c);
          }
        }
      } catch (e) {
        console.error('Reply load failed', e);
      }
    },
    pointerDown(e) {
      if (! e.target.classList.contains('gmf-post-card-image') && ! e.target.classList.contains('gmf-post-modal-content-image-img')) {
        return;
      }
      
      // Track pointers for pinch/pan
      if (!this.activePointers) this.activePointers = {};
      this.activePointers[e.pointerId] = { x: e.clientX, y: e.clientY, type: e.pointerType };
      if (e.target && e.target.setPointerCapture) {
        e.target.setPointerCapture(e.pointerId);
      }

      const pointerIds = Object.keys(this.activePointers);
      if (pointerIds.length === 1) {
        // Start potential pan
        this.startX = e.clientX;
        this.startY = e.clientY;
      } else if (pointerIds.length === 2) {
        // Initialize pinch
        const [p1, p2] = pointerIds.map(id => this.activePointers[id]);
        this.initialPinchDistance = Math.hypot(p2.x - p1.x, p2.y - p1.y);
        this.initialZoom = this.zoom;
        this.initialPanX = this.panX;
        this.initialPanY = this.panY;
        this.pinchCenterX = (p1.x + p2.x) / 2;
        this.pinchCenterY = (p1.y + p2.y) / 2;
        const image = this.$refs.image;
        if (image) {
          const rect = image.getBoundingClientRect();
          const rectCenterX = rect.left + rect.width / 2;
          const rectCenterY = rect.top + rect.height / 2;
          this.initialImageCenterX = rectCenterX - this.initialPanX;
          this.initialImageCenterY = rectCenterY - this.initialPanY;
        }
      }
    },
    pointerMove(e) {
      if (!this.activePointers || !this.activePointers[e.pointerId]) return;
      // Update pointer position
      this.activePointers[e.pointerId].x = e.clientX;
      this.activePointers[e.pointerId].y = e.clientY;

      const pointerIds = Object.keys(this.activePointers);
      if (pointerIds.length === 2) {
        // Pinch-zoom
        const [p1, p2] = pointerIds.map(id => this.activePointers[id]);
        const currentDistance = Math.hypot(p2.x - p1.x, p2.y - p1.y);
        if (this.initialPinchDistance > 0) {
          const scale = currentDistance / this.initialPinchDistance;
          const newZoom = Math.max(1.0, Math.min(6.0, this.initialZoom * scale));
          const fX = (p1.x + p2.x) / 2;
          const fY = (p1.y + p2.y) / 2;
          const ratio = newZoom / this.initialZoom;
          // Keep the focal point stationary on screen: newPan = r*initialPan - (1-r)*(F - elementCenter)
          this.panX = (ratio * this.initialPanX) - ((1 - ratio) * (fX - this.initialImageCenterX));
          this.panY = (ratio * this.initialPanY) - ((1 - ratio) * (fY - this.initialImageCenterY));
          this.zoom = newZoom;
          this.updatePanConstraints();
          if (e.cancelable) e.preventDefault();
        }
      } else if (pointerIds.length === 1) {
        // Pan only when zoomed in to avoid fighting with scroll
        if (this.zoom > 1.0 && this.startX && this.startY) {
          const deltaX = e.clientX - this.startX;
          const deltaY = e.clientY - this.startY;
          this.panX += deltaX;
          this.panY += deltaY;
          this.startX = e.clientX;
          this.startY = e.clientY;
          this.updatePanConstraints();
          if (e.cancelable) e.preventDefault();
        }
      }
    },
    pointerUp(e) {
      if (this.activePointers) {
        delete this.activePointers[e.pointerId];
      }
      const pointerIds = this.activePointers ? Object.keys(this.activePointers) : [];
      if (pointerIds.length === 0) {
        this.startX = 0;
        this.startY = 0;
        this.initialPinchDistance = 0;
      } else if (pointerIds.length === 1) {
        // Transition from pinch to single pointer
        const remaining = this.activePointers[pointerIds[0]];
        this.initialPinchDistance = 0;
        this.startX = remaining.x;
        this.startY = remaining.y;
      }
    },
    applyZoom(zoomDelta, focalX = null, focalY = null) {
      const image = this.$refs.image;
      if (!image) return;
      
      const rect = image.getBoundingClientRect();
      const rectCenterX = rect.left + rect.width / 2;
      const rectCenterY = rect.top + rect.height / 2;
      
      const fX = focalX !== null ? focalX : rectCenterX;
      const fY = focalY !== null ? focalY : rectCenterY;
      
      const oldZoom = this.zoom;
      const newZoom = Math.max(1.0, Math.min(6.0, oldZoom + zoomDelta));
      if (newZoom === oldZoom) return;
      
      const ratio = newZoom / oldZoom;
      const elementCenterX = rectCenterX - this.panX;
      const elementCenterY = rectCenterY - this.panY;
      
      this.panX = (ratio * this.panX) + ((1 - ratio) * (fX - elementCenterX));
      this.panY = (ratio * this.panY) + ((1 - ratio) * (fY - elementCenterY));
      this.zoom = newZoom;
      
      this.$nextTick(() => {
        this.updatePanConstraints();
      });
    },
    wheel(e) {
      this.applyZoom(-e.deltaY / 1000, e.clientX, e.clientY);
    },
    zoomIn() {
      this.applyZoom(0.4);
    },
    zoomOut() {
      this.applyZoom(-0.4);
    },
    updatePanConstraints() {
      const image = this.$refs.image;
      if (!image) return;
      const rect = image.getBoundingClientRect();
      const overflowX = rect.width - image.clientWidth;
      const overflowY = rect.height - image.clientHeight;
      const maxPanX = Math.max(0, overflowX) / 2;
      const maxPanY = Math.max(0, overflowY) / 2;
      this.panX = Math.max(-maxPanX, Math.min(maxPanX, this.panX));
      this.panY = Math.max(-maxPanY, Math.min(maxPanY, this.panY));
    }
  },
  watch: {
    selectedIndex: {
      handler() {
        this.zoom = 1;
        this.panX = 0;
        this.panY = 0;
        if (this.$refs.postCard) {
          this.$refs.postCard.scrollTop = 0;
        }
      },
    },
  },
};
</script>
